import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

/**
 * Hook para excluir uma categoria de produto (core.ProductCategory)
 * Só permite excluir categorias que não possuem produtos associados.
 */
const useDeleteCoreProductCategory = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (categoryId: number) => {
      return fetch(
        `${API}/api/semeadora/core_product_categories/${categoryId}/`,
        {
          method: "DELETE",
        },
      );
    },
    onSuccess: () => {
      // Invalidar cache da lista de categorias
      queryClient.invalidateQueries({ queryKey: ["core_product_categories"] });
    },
    onError: (error) => {
      console.error("Erro ao excluir categoria de produto", error);
    },
  });
};

export default useDeleteCoreProductCategory;
